import { app } from '../../../../../app';

app.component('idpAuthenticatorManageTabs', {
    templateUrl: require('./idp-authenticator-manage-tabs.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/idp-authenticators/manage/tabs/idp-authenticator-manage-tabs.component.js